import React from 'react'
import { ShoppingCart, GraduationCap, Plane, Heart, Sparkles, Code } from 'lucide-react'

const Interests = () => {
  const interests = [
    {
      title: "电商技术创新",
      description: "深耕电商领域，探索搜索算法、推荐系统等技术在商业场景中的应用",
      icon: ShoppingCart,
      color: "from-blue-500 to-cyan-600",
      keywords: ["搜索算法", "推荐系统", "用户体验", "商业智能"]
    },
    {
      title: "教育科技",
      description: "关注AI时代的学习新范式，推动教育技术的创新与发展",
      icon: GraduationCap,
      color: "from-green-500 to-teal-600",
      keywords: ["在线教育", "学习方法", "知识分享", "技能提升"]
    },
    {
      title: "旅行与文化探索",
      description: "通过旅行体验不同文化，用技术记录和分享旅行见闻",
      icon: Plane,
      color: "from-purple-500 to-pink-600",
      keywords: ["文化交流", "旅行记录", "摄影分享", "地理探索"]
    },
    {
      title: "心理健康科技",
      description: "运用技术手段关注心理健康，开发有温度的心理健康应用",
      icon: Heart,
      color: "from-red-500 to-rose-600",
      keywords: ["冥想工具", "心理健康", "正念练习", "情绪管理"]
    },
    {
      title: "玄学与现代技术",
      description: "探索传统玄学与现代科技的结合，创造有趣的数字化体验",
      icon: Sparkles,
      color: "from-yellow-500 to-orange-600",
      keywords: ["传统文化", "Web3", "AI占卜", "文化传承"]
    },
    {
      title: "AI全栈开发",
      description: "专注于AI技术的全栈应用，构建智能化的产品解决方案",
      icon: Code,
      color: "from-indigo-500 to-purple-600",
      keywords: ["大语言模型", "全栈开发", "AI应用", "产品设计"]
    }
  ]

  return (
    <section id="interests" className="section-padding bg-white">
      <div className="container-custom">
        <div className="text-center mb-16">
          <h2 className="gradient-text mb-4">兴趣领域</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            技术与人文的交汇点，用代码探索世界的无限可能
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {interests.map((interest, index) => (
            <div key={index} className="card hover:scale-105 transform transition-all duration-300 group">
              <div className={`w-16 h-16 rounded-2xl bg-gradient-to-br ${interest.color} flex items-center justify-center mb-6 group-hover:scale-110 transition-transform duration-300`}>
                <interest.icon size={32} className="text-white" />
              </div>
              
              <h3 className="text-xl font-bold text-gray-800 mb-3">{interest.title}</h3>
              <p className="text-gray-600 mb-4 leading-relaxed">{interest.description}</p>
              
              <div className="flex flex-wrap gap-2">
                {interest.keywords.map((keyword, keywordIndex) => (
                  <span
                    key={keywordIndex}
                    className="px-3 py-1 bg-gray-100 text-gray-700 rounded-full text-sm font-medium hover:bg-primary-50 hover:text-primary-700 transition-colors cursor-default"
                  >
                    {keyword}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* 底部说明 */}
        <div className="text-center mt-16">
          <div className="card inline-block bg-gradient-to-r from-primary-50 to-accent-50 border-2 border-primary-100">
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 bg-gradient-to-br from-primary-500 to-accent-500 rounded-full flex items-center justify-center">
                <Sparkles size={24} className="text-white" />
              </div>
              <div className="text-left">
                <h4 className="font-semibold text-gray-800">持续探索中</h4>
                <p className="text-gray-600 text-sm">在AI时代寻找技术与人文的完美结合</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Interests 